@switch (mode()) {
  @case ('slider') {
    <div class="ab-frame">
      <img class="ab-img" [src]="aiUrl()" alt="AI" />
      <img
        class="ab-img ab-overlay"
        [src]="originalUrl()"
        [style.clipPath]="clipPath()"
        alt="Originale"
      />
      <span class="ab-label ab-label-left">Originale</span>
      <span class="ab-label ab-label-right">AI</span>
      <input
        type="range"
        class="ab-slider"
        min="0"
        max="100"
        [value]="sliderPosition()"
        (input)="onSliderInput($event)"
      />
      <div class="ab-handle" [style.left.%]="sliderPosition()"></div>
    </div>
  }
  @case ('side-by-side') {
    <div class="ab-side">
      <div class="ab-side-col">
        <img class="ab-img" [src]="originalUrl()" alt="Originale" />
        <span class="ab-label ab-label-bottom">Originale</span>
      </div>
      <div class="ab-side-col">
        <img class="ab-img" [src]="aiUrl()" alt="AI" />
        <span class="ab-label ab-label-bottom">AI</span>
      </div>
    </div>
  }
  @case ('tap') {
    <div
      class="ab-frame ab-tap"
      (pointerdown)="showOriginalPreview()"
      (pointerup)="showAiPreview()"
      (pointerleave)="showAiPreview()"
      (pointercancel)="showAiPreview()"
    >
      <img
        class="ab-img"
        [src]="showAi() ? aiUrl() : originalUrl()"
        [alt]="showAi() ? 'AI' : 'Originale'"
      />
      <span class="ab-label ab-label-top"
        >{{ showAi() ? 'AI' : 'Originale' }} — tieni premuto per vedere
        l'originale</span
      >
    </div>
  }
}
